import React from 'react'

const Select = ({ list, value, onChange }) => (
  <div
    style={{
      width: 326,
      paddingLeft: 20,
      paddingBottom: 20,
      display: 'inline-block',
      textAlign: 'left',
    }}
  >
    <div className="selector">
      <span>
        {(list.filter(e => e.key === value)[0] || { value: '' }).value}
      </span>
      <select value={value} onChange={e => onChange(e.target.value)}>
        {list.map(e => (
          <option
            key={e.key}
            value={e.key}
            disabled={e.disabled}
            style={
              e.disabled
                ? {
                    fontStyle: 'italic',
                    fontSize: 15,
                  }
                : {}
            }
          >
            {e.value}
          </option>
        ))}
      </select>
    </div>
  </div>
)
export default Select



// WEBPACK FOOTER //
// ./components/visual/Select.js